export class FilePathParser {
  static getPath(parentsList: string[]): string {
    return `../${parentsList.join('/')}/`;
  }
}
